import { editStaff, fetchStaff, signUpStaff } from "./asyncThunks";

export const signUpStaffBuilder = (builder) => {
  builder.addCase(signUpStaff.pending, (state) => {
    state.signUpStaffPending = true;
  });
  builder.addCase(signUpStaff.fulfilled, (state, action) => {
    state.signUpStaffPending = false;
    state.staff.data = [action.payload.staff, ...state.staff.data];
  });
  builder.addCase(signUpStaff.rejected, (state) => {
    state.signUpStaffPending = false;
  });
};

export const fetchStaffBuilder = (builder) => {
  builder.addCase(fetchStaff.pending, (state) => {
    state.fetchStaffPending = true;
  });
  builder.addCase(fetchStaff.fulfilled, (state, action) => {
    state.fetchStaffPending = false;
    state.staff.data = action.payload.data;
    state.staff.total = action.payload.total;
    state.staff.perPage = action.payload.perPage;
  });
  builder.addCase(fetchStaff.rejected, (state) => {
    state.fetchStaffPending = false;
  });
};

export const editStaffBuilder = (builder) => {
  builder.addCase(editStaff.pending, (state) => {
    state.editStaffPending = true;
  });
  builder.addCase(editStaff.fulfilled, (state, action) => {
    state.editStaffPending = false;
    state.staff.data = state.staff.data.map((s) => {
      if (s.id === action.payload.staff.id) {
        return action.payload.staff;
      } else {
        return s;
      }
    });
  });
  builder.addCase(editStaff.rejected, (state) => {
    state.editStaffPending = false;
  });
};
